import { NotificationsPageConfig } from './notifications.config';

/**
 * Maps the raw Cases enum name shipped on the payload to a human-friendly label for the Type
 * column. Falls back to splitting the PascalCase enum into words when an unmapped type slips
 * through, so new notification types don't show up as gibberish until this catalog catches up.
 */
const CASES_TYPE_LABELS: Record<string, string> = {
  CaseAgentAssignedToMe: 'Assignment',
  CaseAgentReassignedAway: 'Reassignment',
  CaseAgentStatusChanged: 'Status change',
  CaseAgentResolved: 'Resolved',
  CaseAgentReopened: 'Reopened',
  CaseAgentResponseTimeSLA: 'SLA warning',
  CaseAgentResolutionTimeSLA: 'SLA warning',
  CaseAgentOverdue: 'Overdue',
  CaseAgentApprovalRequested: 'Approval requested',
  CaseAgentTransferedToER: 'Transferred to ER',
  CaseAgentChecklistCompleted: 'Checklist completed',
  CaseAgentWatcherAddMe: 'Watcher added',
  CaseAgentComNewMessage: 'New message',
  CaseAgentComNewMessageFromEmployee: 'New message',
  CaseAgentComNewFile: 'New file',
  CaseManagerTransferedToER: 'Transferred to ER',
  CaseManagerAgentOverCapacity: 'Capacity',
  CaseManagerAgentOOO: 'Agent OOO',
  CaseManagerCaseHandedOff: 'Handed off',
  CaseManagerApprovalAssignedToMe: 'Approval assigned',
  CaseManagerResponseTimeSLA: 'SLA breach',
  CaseManagerResolutionTimeSLA: 'SLA breach',
};

export const CASES_NOTIFICATIONS_CONFIG: NotificationsPageConfig = {
  routePrefix: '/cases',
  numberField: 'caseNumber',
  typeLabels: CASES_TYPE_LABELS,
  // Equivalent to the previous two-step strip: `^Case(Agent|Manager)Com?` then `^Case(Agent|Manager)`.
  typePrefixPattern: /^Case(?:Agent|Manager)(?:Com?)?/,
  autIdPrefix: '',
  rowAutIdPrefix: '',
};
